import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useMemo, useState, useRef, useEffect } from 'react';
import mainAxios from '../../../services/mainAxios';
import { useAppContext } from '../../../AppContext';
import moment from 'moment';

const TransactionSyncInfo = ({ accountNumber, refresh }) => {
  const [syncLogData, setSyncLogData] = useState({ loading: false, data: null });
  const overlayRef = useRef(null);
  const {
    selectedCompany: [selectedCompany],
    user: [user]
  } = useAppContext();

  const syncContent = useMemo(() => {
    const syncLog = syncLogData?.data;
    if (!syncLog) return null;

    const { lastAttempt, lastSuccessful } = syncLog;

    return (
      <div style={{ padding: '10px', minWidth: '320px', maxWidth: '400px' }}>
        {lastSuccessful && (
          <div style={{ marginBottom: lastAttempt && !lastAttempt.successful ? '12px' : '0' }}>
            <div style={{ fontWeight: 600, color: '#28a745', marginBottom: '8px', fontSize: '1em' }}>
              ✓ Last Successful Attempt
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '0.9em' }}>
              <div style={{ display: 'flex' }}>
                <span style={{ fontWeight: 600, minWidth: '70px' }}>Date:</span>
                <span>{moment(lastSuccessful.recordDate).format('DD/MM/YYYY HH:mm')}</span>
              </div>
              <div style={{ display: 'flex' }}>
                <span style={{ fontWeight: 600, minWidth: '70px' }}>User:</span>
                <span>{lastSuccessful.recordUser || 'N/A'}</span>
              </div>
              {lastSuccessful.message && (
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <span style={{ fontWeight: 600, minWidth: '70px' }}>Message:</span>
                  <span style={{ color: '#6c757d', flex: 1 }}>{lastSuccessful.message}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {lastAttempt && !lastAttempt.successful && (
          <div style={{
            paddingTop: lastSuccessful ? '12px' : '0',
            borderTop: lastSuccessful ? '1px solid #ddd' : 'none'
          }}>
            <div style={{ fontWeight: 600, color: '#dc3545', marginBottom: '8px', fontSize: '1em' }}>
              ✗ Last Attempt Failed
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '0.9em' }}>
              <div style={{ display: 'flex' }}>
                <span style={{ fontWeight: 600, minWidth: '70px' }}>Date:</span>
                <span>{moment(lastAttempt.recordDate).format('DD/MM/YYYY HH:mm')}</span>
              </div>
              <div style={{ display: 'flex' }}>
                <span style={{ fontWeight: 600, minWidth: '70px' }}>User:</span>
                <span>{lastAttempt.recordUser || 'N/A'}</span>
              </div>
              {lastAttempt.message && (
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <span style={{ fontWeight: 600, minWidth: '70px' }}>Error:</span>
                  <span style={{ color: '#dc3545', flex: 1 }}>{lastAttempt.message}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }, [syncLogData]);

  const getTransactionSyncLog = () => {
    if (!accountNumber || accountNumber === null ) {
      return;
    }

    setSyncLogData({ loading: true, data: null });

    mainAxios
      .post('/transactions/search', {
        object: "GetTransactionSyncLog",
        company: selectedCompany,
        params: {accountNumber},
      })
      .then(res => {
        if (res?.data?.status === true && res?.data?.content?.[0]) {
          setSyncLogData({ loading: false, data: res.data.content[0] });
        } else {
          setSyncLogData({ loading: false, data: null });
        }
      })
      .catch(err => {
        console.error('Error fetching transaction sync log:', err);
        setSyncLogData({ loading: false, data: null });
      });
  };

  useEffect(() => {
    if (accountNumber && accountNumber !== null && accountNumber !== undefined && accountNumber !== '') {
      getTransactionSyncLog();
    } else {
      setSyncLogData({ loading: false, data: null });
    }
  }, [accountNumber, refresh,selectedCompany]);

  if (!accountNumber || accountNumber === null) {
    return null;
  }

  return (
    <>
      <button
        className={`btn btn-sm ${
          syncLogData?.data?.lastAttempt && !syncLogData.data.lastAttempt.successful
            ? 'btn-outline-warning'
            : 'btn-outline-success'
        } ml-2`}
        onClick={(e) => overlayRef.current?.toggle(e)}
        disabled={!syncContent}
      >
        <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
        Pulse Info
      </button>
      <OverlayPanel ref={overlayRef}>
        {syncContent}
      </OverlayPanel>
    </>
  );
};

export default TransactionSyncInfo;